import { WelcomePanel } from '@/features/workspace';

export function WelcomePage() {
  return <WelcomePanel />;
}
